<template>
  <div class="">
    <Modal
      v-model="followUpRecListModal"
      width="600"
      :title="followUpRecTitle"
      :mask-closable="false"
      :loading="loading"
      @on-ok="followUpRecList('followUpRecListForm')"
    >
      <Form
        ref="followUpRecListForm"
        :model="followUpRecListForm"
        :label-width="120"
        label-position="left"
      >
        <FormItem label="企业跟进提醒">
          <RadioGroup v-model="followUpRecListForm.radio">
            <Radio label="male"> 不提醒</Radio>
            <Radio label="female">提醒</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          label="提醒时间"
          v-show="followUpRecListForm.radio === 'female'"
        >
          <SmyDatePicker
            transfer
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            placeholder="请选择提醒时间"
            style="width: 100%"
            :options="dateDisabledOptions"
            :value="followUpRecListForm.data"
            @input="followUpRecListForm.data = $event"
          />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UpLoadImg from '@/components/UploadImg'
import SmyDatePicker from '@/components/SmyDatePicker'
import { followUpType } from '@/assets/globalData'

export default {
  components: {
    UpLoadImg,
    SmyDatePicker
  },
  props: {
    agentId: {
      type: Number
    },
    followUpRecTitle: {
      type: String
    },
    followUpRecModal: {
      type: Boolean,
      required: true
    },
    followUpRecRow: {
      type: Object
    }
  },
  data() {
    return {
      loading: true,
      multiple: true,
      num: 6,
      override: true,
      followUpRecListModal: this.followUpRecModal,
      followUpRecListForm: {
        epId: '',
        data: '',
        radio: ''
      },
      typeList: followUpType,
      // 日期配置 （无法选择今日之前的日期）
      dateDisabledOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      }
    }
  },
  methods: {
    // 保存编辑数据
    followUpRecList(val) {
      let datalist = {
        epId: this.followUpRecListForm.epId,
        remind_type: this.followUpRecListForm.radio === 'male' ? 0 : 1,
        remind_time: this.followUpRecListForm.data
      }
      let data = {
        ...datalist
      }
      let url = '/enterprise/followupremind/save'
      this.$http.post(url, data).then(res => {
        if (res.success) {
          let msg = '新增成功'
          this.$Message.success(msg)
          this.followUpRecListModal = false
          this.$emit('callback')
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    reload() {
      // this.agentId = this.followUpRecRow.id
      this.followUpRecListForm.epId = this.followUpRecRow.id ? this.followUpRecRow.id : this.followUpRecRow.fk_t_enterprise_id
      this.$http
        .get('/enterprise/followupremind/find', {
          params: {
            epId: this.followUpRecRow.id ? this.followUpRecRow.id : this.followUpRecRow.fk_t_enterprise_id
          }
        })
        .then(res => {
          if (res.data) {
            this.followUpRecListForm = {
              epId: res.data.epId,
              data: res.data.remind_time,
              radio: res.data.remind_type === 0 ? 'male' : 'female'
            }
          }
          if (res.data === null) {
            this.followUpRecListForm = {
              epId: this.followUpRecRow.id ? this.followUpRecRow.id : this.followUpRecRow.fk_t_enterprise_id,
              data: null,
              radio: 'male'
            }
          }
        })
    }
  },
  watch: {
    followUpRecModal(val) {
      this.followUpRecListModal = val
      if (val) {
        this.reload()
      }
    },
    followUpRecListModal(val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/FollowupremindModals.vue